import React,{useState,useEffect} from 'react'
import {URL} from '../Helper/helper'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import './AdminComponent.css'

import 'react-toastify/dist/ReactToastify.css';

function AdminComponent() {

  const navigate = useNavigate()
  const user_info = JSON.parse(localStorage.getItem('user'))
  const[reservations,setReservations] = useState([])
  const[searchDate,setSearchDate] = useState('')
  const[searchTxn,setSearchTxn] = useState('')
  const[startTime,setStartTime] = useState('')
  const[endTime,setEndTime] = useState('')
  const[searchText,setSearchText] = useState('')

  const[dateSelected,setDateSelected] = useState(new Date().toLocaleDateString("fr-CA"))
  const[currentDate,setCurrentDate] = useState(new Date().toLocaleDateString("fr-CA"))
  const[bookingRowEdited,setBookingRowEdited] = useState({
    "booking_item": null,
    "booking_date": null,
    "booking_time_start": null,
    "booking_time_end": null,
    "booking_price": null,
    "booking_status": null
  })
  const[courtBooked,setCourtBooked] = useState('')
  const[price,setPrice] = useState(0.00)
  const[isRefreshing,setIsRefreshing] = useState(false)
  const[isLoading,setIsLoading] = useState(true)

  useEffect(() =>{

    if(!localStorage.getItem('user')){
        navigate('/')
    }
    async function invokeUsers(){
        setIsLoading(true);
        try {
            const user_reservations = await fetch(`${URL}`+'/bookings')
            const cust_booking_response = await user_reservations.json()
            const new_cust_booking_response = cust_booking_response.map(item =>{
                return {...item,isEditing:false}
            })
            setReservations(new_cust_booking_response)
        } catch (error) {
            console.error('Error fetching bookings:', error);
            toast.error('Failed to load bookings', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } finally {
            setIsLoading(false);
        }
    }

    invokeUsers()
  },[searchText])

  const refreshBookings = async () => {
    setIsRefreshing(true);
    try {
      const user_reservations = await fetch(`${URL}/bookings`)
      const cust_booking_response = await user_reservations.json()
      const new_cust_booking_response = cust_booking_response.map(item =>{
          return {...item,isEditing:false}
      })
      setReservations(new_cust_booking_response)
      toast.success('Bookings refreshed successfully!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.error('Error refreshing bookings:', error);
      toast.error('Failed to refresh bookings', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setIsRefreshing(false);
    }
  }
  const options = (method = "GET",body) =>{
    return {
        method,
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(body)
    }
  }
  const editBookings = async(bookingid,rowid) =>{
        console.log(bookingid)
        //toggleRow(rowid)
        console.log('edited booking row ',bookingRowEdited)
        try{

            const edit_booking_response = await fetch(`${URL}` + '/bookings/'+`${bookingid}`, options("PATCH",bookingRowEdited));

            if(edit_booking_response.ok){
                const edit_booking_status = await edit_booking_response.json();
                const dataUpdate = [...reservations]
                dataUpdate[rowid] = edit_booking_status;
                setReservations([...dataUpdate])
                console.log('update response :',edit_booking_response)
                toggleRow(bookingid,rowid)
                toast.success('🦄 Wow Row Updated!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
            }
            else{
               // alert('Update Failed')
               toast.error('🦄 OOps Update Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
        }
        catch(err){
            console.log(err)
        }

  }

  const toggleRow = (_id,rid,) => {
    const new_cust_booking_response1 = reservations.map((item,idx) =>{
        if(_id === item._id){
            if(item.isEditing){
                item.booking_date  = bookingRowEdited.booking_date !== null ? bookingRowEdited.booking_date : item.booking_date;
                item.booking_time_start  = bookingRowEdited.booking_time_start !== null ? bookingRowEdited.booking_time_start : item.booking_time_start;
                item.booking_time_end  = bookingRowEdited.booking_time_end !== null ? bookingRowEdited.booking_time_end : item.booking_time_end;
                item.booking_item  = bookingRowEdited.booking_item !== null ? bookingRowEdited.booking_item : item.booking_item;
                item.booking_price  = bookingRowEdited.booking_price !== null ? bookingRowEdited.booking_price : item.booking_price;
                item.booking_status  = bookingRowEdited.booking_status !== null ? bookingRowEdited.booking_status : item.booking_status;
                return {...item,isEditing:!item.isEditing}
            }
            if(!item.isEditing){
                return {...item,isEditing:!item.isEditing}
            }

        }
        return item;

    })
    setReservations(new_cust_booking_response1)
  }
  const handleChange = (e,rowdata) => {
    const{name,value} = e.target;
    setBookingRowEdited({...bookingRowEdited,[name]:value})
  }
  const deleteBookings = async(bookingid,rowid) => {

    if(window.confirm('Are you Sure You wanna Delete the Record at Row-No - '+`${rowid+1}`)) {

        try{
            // First, fetch the booking to be deleted
            const bookingToDelete = reservations.find(r => r._id === bookingid);
            if (!bookingToDelete) {
                toast.error('Booking not found for deletion.', { position: "top-right", autoClose: 3000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
                return;
            }

            // Then, save it to the deleted bookings table
            const save_deleted_booking_response = await fetch(`${URL}/deleted-bookings`, options("POST", { ...bookingToDelete }));

            if(save_deleted_booking_response.ok){
                // If successfully saved to deleted bookings, then delete from main bookings
                const delete_booking_response = await fetch(`${URL}/bookings/${bookingid}`, options("DELETE"));

                if(delete_booking_response.ok){

                    const filtered_reservation_bydate = reservations.filter(item =>{
                        const textMatch = searchText.toLowerCase() === '' ? item : item.userName.toLowerCase().includes(searchText.toLowerCase());
                        const dateMatch = searchDate === '' ? item : new Date(item.booking_date).toLocaleDateString() === new Date(searchDate).toLocaleDateString();
                        const txnMatch = !searchTxn ? item : item?.bookingID?.toLowerCase()?.includes(searchTxn.toLowerCase());
                        if(textMatch && dateMatch && txnMatch)
                            return textMatch && dateMatch && txnMatch;

                    })

                    const dataDelete = [...filtered_reservation_bydate];
                    // Find the index of the item to delete in the filtered array
                    const indexToDelete = dataDelete.findIndex(item => item._id === bookingid);
                    if (indexToDelete > -1) {
                        dataDelete.splice(indexToDelete, 1);
                    }
                    setReservations([...dataDelete])
                    toast.success('🦄 Wow Row Deleted and Moved to Deleted Bookings!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                        });
                } else {
                    // If deletion from main table fails, show error
                    toast.error('Failed to delete booking from main table.', { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
                }
            } else {
                // If saving to deleted bookings fails, show error
                toast.error('Failed to move booking to deleted records.', { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
            }
        }catch(err){
            console.log(err)
            toast.error('An error occurred during booking deletion process.', { position: "top-right", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined, theme: "colored" });
        }
    }
  }
  return (
      <div className="admin-panel">
          <div className='container admin-container'>
              <div className="row mt-5">
                <div className="col-md-12 col-sm-12">
                  <div className="failed-bookings-header d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h3 className="mb-1">
                        <i className="fa fa-cogs text-warning me-2"></i>
                        Manage Bookings ({reservations.length})
                      </h3>
                      <p className="text-muted">Manage all booking records and transactions</p>
                    </div>
                    <div className="failed-bookings-actions">
                      <button
                        className="btn btn-outline-secondary me-2"
                        onClick={refreshBookings}
                        disabled={isRefreshing}
                      >
                        {isRefreshing ? (
                          <>
                            <i className="fa fa-spinner fa-spin me-1"></i>
                            Refreshing...
                          </>
                        ) : (
                          <>
                            <i className="fa fa-refresh me-1"></i>
                            Refresh
                          </>
                        )}
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() => navigate('/user')}
                      >
                        <i className="fa fa-arrow-left me-1"></i>
                        Back to Dashboard
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Filter Section */}
              <div className="mb-4">
                  <div className="table-responsive">
                      <div className="d-flex align-items-center gap-3 mb-3" style={{padding: '1rem', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '0.375rem'}}>
                          <input
                              type="search"
                              className='form-control'
                              name="search"
                              placeholder='Search User...'
                              value={searchText}
                              onChange={e => setSearchText(e.target.value)}
                              id="search"
                              style={{flex: '1'}}
                          />
                          <input
                              type="search"
                              className='form-control'
                              name="search"
                              placeholder='Search Transaction...'
                              value={searchTxn}
                              onChange={e => setSearchTxn(e.target.value)}
                              id="searchTxn"
                              style={{flex: '1'}}
                          />
                          <input
                              type="date"
                              value={searchDate}
                              onChange={e => setSearchDate(e.target.value)}
                              className='form-control'
                              style={{flex: '1'}}
                          />
                          <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={() => {
                                  setSearchText('');
                                  setSearchTxn('');
                                  setSearchDate('');
                              }}
                              disabled={!searchText && !searchTxn && !searchDate}
                              style={{minWidth: '120px'}}
                          >
                              Clear Filters
                          </button>
                      </div>

                      {/* Filter Summary */}
                      {(searchText || searchTxn || searchDate) && (
                          <div className="mb-3" style={{padding: '0.5rem 1rem', backgroundColor: '#e9ecef', borderRadius: '0.375rem'}}>
                              <small className="text-muted">
                                  Active Filters:
                                  {searchText && (
                                      <span className="badge bg-primary ms-1 me-1">
                                          User: "{searchText}"
                                      </span>
                                  )}
                                  {searchTxn && (
                                      <span className="badge bg-info ms-1 me-1">
                                          Transaction: "{searchTxn}"
                                      </span>
                                  )}
                                  {searchDate && (
                                      <span className="badge bg-success ms-1 me-1">
                                          Date: {searchDate}
                                      </span>
                                  )}
                                  | Showing filtered results
                              </small>
                          </div>
                      )}
                  </div>
              </div>

              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                  <div className="text-center">
                    <div className="spinner-border text-warning" role="status" style={{ width: '3rem', height: '3rem' }}>
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 text-muted">Loading booking data...</p>
                  </div>
                </div>
              ) : (
                <div className="customer-table table-responsive">
                <table className='table table-bordered table-hover my-5 admin-tab'>
                    <thead className="table-warning text-center">
                        <tr>
                            <th>S.No</th>
                            <th>Txn#</th>
                            <th>User Name</th>
                            <th>Booking Date</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Court No</th>
                            <th>Price</th>
                            <th>Grand Total</th>
                            <th>Discount %</th>
                            <th>Net Price</th>
                            <th>Pay Mode</th>
                            <th>Created On</th>
                            <th>Contact</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            reservations.length > 0 ?
                            reservations.filter(item =>{
                                const textMatch = searchText.toLowerCase() === '' ? item : item?.userName.toLowerCase().includes(searchText.toLowerCase());
                                const dateMatch = searchDate === '' ? item : new Date(item?.booking_date).toLocaleDateString() === new Date(searchDate).toLocaleDateString();
                                const txnMatch = !searchTxn ? item : item?.bookingID?.toLowerCase()?.includes(searchTxn.toLowerCase());
                                if(textMatch && dateMatch && txnMatch)
                                    return textMatch && dateMatch && txnMatch;
                            })
                            .map((r,i) => (<tr key={i}>
                                        <td>{i+1}</td>
                                        <td>{r.bookingID}</td>
                                        <td>{r.userName}</td>
                                        {
                                            r.isEditing ?
                                            <td>
                                            <input
                                                type="date"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                //dateFormat="yyyy-MM-dd"
                                                className='form-control text-center'
                                                name="booking_date"
                                                id="booking_date"
                                                defaultValue ={r.booking_date}
                                                onChange = {e =>handleChange(e,r)}
                                            />

                                            </td>
                                            :
                                            <td>{r.booking_date}</td>
                                        }

                                         {
                                            r.isEditing ?
                                            <td>
                                             <input
                                                type="time"
                                                className='form-control text-center'
                                                name="booking_time_start"
                                                id="booking_time_start"
                                                defaultValue ={r.booking_time_start}
                                                onChange = {e =>handleChange(e,r)}
                                            /></td>
                                            :
                                            <td>{r.booking_time_start}</td>
                                        }
                                        {
                                            r.isEditing ?
                                            <td>
                                             <input
                                                type="time"
                                                className='form-control text-center'
                                                name="booking_time_end"
                                                id="booking_time_end"
                                                defaultValue ={r.booking_time_end}
                                                onChange={e => handleChange(e,r)}
                                            /></td>
                                            :
                                            <td>{r.booking_time_end}</td>
                                        }
                                         {
                                            r.isEditing ?
                                            <td>
                                             <input
                                                type="text"
                                                className='form-control text-center'
                                                name="booking_item"
                                                id="booking_item"
                                                defaultValue ={r.booking_item}
                                                onChange={e =>handleChange(e,r)}
                                            /></td>
                                            :
                                            <td>{r.booking_item}</td>
                                        }
                                        {
                                            r.isEditing ?
                                            <td>
                                             <input
                                                type="text"
                                                className='form-control text-center'
                                                name="booking_price"
                                                id="booking_price"
                                                defaultValue ={r.booking_price.toFixed(2)}
                                                onChange={e =>handleChange(e,r)}
                                            /></td>
                                            :
                                            <td className="text-end" title={`Price: A$${r.booking_price.toFixed(2)}`}>
                                                A${r.booking_price.toFixed(2)}
                                            </td>
                                        }
                                        <td className="text-end" title={`Grand Total: A$${r.grand_total?.toFixed(2)}`}>
                                            A${r.grand_total?.toFixed(2)}
                                        </td>
                                        <td className="text-center" title={`Discount: ${r.discount}%`}>
                                            {r.discount}%
                                        </td>
                                        <td className="text-end" title={`Net Price: A$${r.net_price?.toFixed(2)}`}>
                                            A${r.net_price?.toFixed(2)}
                                        </td>
                                        {
                                                r.isEditing && r.booking_status !== 'Online'?
                                                 <td>
                                                    <select className='form-control text-center' id="cash_mode"  name="booking_status" onChange={e =>handleChange(e,r)}>
                                                        <option value="-1">select</option>
                                                        <option value="Cash">Cash</option>
                                                        <option value="EFTPOS">EFTPOS</option>
                                                    </select>
                                                 </td>
                                                 :
                                                 <td>
                                                    <span className={r.booking_status === 'UnPaid' ? 'bg-danger text-white' : r.booking_status === 'Online' ? 'bg-warning text-white': r.booking_status === 'Complimentary' ? 'bg-info text-white' : 'bg-success text-white'}>{ r.booking_status }</span>
                                                 </td>
                                        }

                                        {
                                            <td title={`Created: ${r.createdBy.split('|')[0]} on ${r.createdBy.split('|')[1]}`}>
                                                <div className="created-info">
                                                    <div className="created-by">{r.createdBy.split('|')[0]}</div>
                                                    <div className="created-date">{r.createdBy.split('|')[1]}</div>
                                                </div>
                                            </td>
                                        }
                                        {
                                            <td title={`Contact: ${r.contact}, Email: ${r.email}`}>
                                                <div className="contact-info">
                                                    <div className="contact-phone">{r.contact}</div>
                                                    <div className="contact-email">{r.email}</div>
                                                </div>
                                            </td>
                                        }
                                        <td>
                                            <div className="action-buttons">
                                            {
                                                r.isEditing ?
                                                <i
                                                    onClick={() =>editBookings(r._id,i)}
                                                    className='fa fa-check'
                                                    title="Save Changes"></i>
                                                :
                                                <i
                                                    onClick={() =>toggleRow(r._id,i)}
                                                    className='fa fa-pencil'
                                                    title="Edit Booking"
                                                ></i>
                                            }
                                            {
                                                 r.isEditing ?
                                                 <i
                                                    onClick={() =>toggleRow(r._id,i)}
                                                    className='fa fa-times'
                                                    title="Cancel Edit"></i>
                                                :
                                                <i
                                                    onClick={() => deleteBookings(r._id,i)}
                                                    className='fa fa-trash'
                                                    title="Delete Booking"></i>
                                            }
                                            </div>
                                        </td>
                                    </tr>)

                            )
                            :
                            <tr>
                                <td colSpan={14} className='text-center'>No Records Available...</td>
                            </tr>
                        }
                    </tbody>
                </table>
                </div>
              )}
          </div>

          {/* Back to Top Button */}
          <button
            className="btn btn-primary back-to-top-btn"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            title="Back to Top"
          >
            <i className="fa fa-arrow-up"></i>
          </button>

          <ToastContainer/>
      </div>
  )
}

export default AdminComponent

// .sort((a, b) => a.booking_date < b.booking_date ? 1 : -1)